import React from 'react'
import lazyLoad from '@utils/lazyLoad'
import history from '@utils/history'
import { Route, Switch } from 'react-router-dom'
import AuthRoute from '@components/Layouts/AuthRoute'
import { ConnectedRouter } from 'connected-react-router'
import Login from '@views/Login'

// Keep historical local links renderable instead of falling through to the shell layout.
export const WORKBENCH_ROUTE_PATHS = ['/workbench', '/local/workbench']

function App() {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/login" exact component={Login} />
        <Route
          path="/forget-password"
          exact
          component={lazyLoad(() => import('@views/Login/ForgetPassword'))}
        />
        <AuthRoute
          path={WORKBENCH_ROUTE_PATHS}
          component={lazyLoad(() => import('@views/Workbench'))}
        />
        <AuthRoute
          path="/"
          component={lazyLoad(() => import('@components/Layouts/Layout'))}
        />
      </Switch>
    </ConnectedRouter>
  )
}
export default App
